import _ from "lodash";
import Moment from "moment";
import moment from 'moment-timezone';

import {DbTypes, AuditSources, AuditTypes} from "../constants";

export const timezone = `GMT${moment().format('ZZ')} (${moment.tz(moment.tz.guess()).zoneAbbr()})`;

export interface IDatabases {
  dbApp?: PouchDB.Database;
  dbLocal?: PouchDB.Database;
  dbMemory?: PouchDB.Database;
}

export interface IDatabase {
  name: string | null;
  dbName: string;
  type: DbTypes;
  db?: PouchDB.Database;
  location?: string;
  connection?: object;
  writable?: boolean;
  searchUrl?: string;
}

export class Database implements IDatabase {
  name: string;
  dbName: string;
  type: DbTypes;
  db?: PouchDB.Database | any;
  location?: string;
  connection?: object;
  writable?: boolean;
  searchUrl?: string;

  constructor(private data?: IDatabase) {
    this.name = _.get(this.data, 'name', null);
    this.dbName = _.get(this.data, 'dbName', null);
    this.type = _.get(this.data, 'type', null);
    this.db = _.get(this.data, 'db', null);
    this.location = _.get(this.data, 'location', null);
    this.connection = _.get(this.data, 'connection', null);
    this.writable = _.get(this.data, 'writable', null);
    this.searchUrl = _.get(this.data, 'searchUrl', null);
  }
}

export interface ICouchModel  {
  _id: string;
  _rev?: string;
}

export interface IAudit {
  device?: IAuditDataDevice;
  server: IAuditData;
}

export interface IAuditData {
  created: IAuditCreation;
  updated: Array<IAuditUpdates>;
}

export interface IAuditDataDevice {
  created: IAuditCreationDevice;
  updated: Array<IAuditUpdatesDevice>;
}

export interface IAuditCreation {
  createdBy: string;
  createdOn: string;
  createdOnUtc: number;
}

export interface IAuditUpdates {
  updatedBy: string;
  updatedOn: string;
  updatedOnUtc: number;
}

export interface IAuditCreationDevice extends IAuditCreation {
  did: string;
}

export interface IAuditUpdates {
  updatedBy: string;
  updatedOn: string;
  updatedOnUtc: number;
}

export interface IAuditUpdatesDevice extends IAuditUpdates {
  did: string;
}

export class CouchModel implements ICouchModel {
  _id: string;
  _rev?: string;
}

export class DbModel implements CouchModel {
  public _id: string;
  public _rev: string;
  public type: string;
  public audit: IAudit;
}

export class Audit implements IAudit {
  device?: IAuditDataDevice = null;
  server: IAuditData = null;

  constructor(data: any, auditType: AuditTypes) {
    const auditData = _.get(data, 'audit');
    const utcDate = Date.now();
    const formattedDate = `${Moment(utcDate).format('DD-MM-YYYY hh:mm:ss A')} ${timezone}`;
    if (auditType === AuditTypes.created || _.isNothing(auditData)) {
      if (_.has(data, 'requestTime')) {
        _.set(this, `${AuditSources.device}.${auditType}.${auditType}By`, _.get(data, 'uid', 'system'));
        _.set(this, `${AuditSources.device}.${auditType}.${auditType}On`, formattedDate);
        _.set(this, `${AuditSources.device}.${auditType}.${auditType}OnUtc`, utcDate);
        _.set(this, `${AuditSources.device}.${auditType}.did`, _.get(data, 'did', _.get(_.oGet(data, 'device', null, true), 'did', 'system')));
      }

      _.set(this, `${AuditSources.server}.${auditType}.${auditType}By`, _.get(data, 'uid', 'system'));
      _.set(this, `${AuditSources.server}.${auditType}.${auditType}On`, formattedDate);
      _.set(this, `${AuditSources.server}.${auditType}.${auditType}OnUtc`, utcDate);

    } else {
      const us = {};
      const ud = {};
      const update = auditData;
      if (_.has(data, 'requestTime')) {
        if (_.isNothing(_.get(update, `${AuditSources.device}.${auditType}`))) {
          _.set(update, `${AuditSources.device}.${auditType}`, []);
        }
        _.set(ud, `${auditType}By`, _.get(data, 'uid', 'system'));
        _.set(ud, `${auditType}On`, formattedDate);
        _.set(ud, `${auditType}OnUtc`, utcDate);
        _.set(ud, `did`, _.get(data, 'did', _.get(_.oGet(data, 'device', null, true), 'did', 'system')));
        _.get(update, `${AuditSources.device}.${auditType}`).push(ud);
      }

      if (_.isNothing(_.get(update, `${AuditSources.server}.${auditType}`))) {
        _.set(update, `${AuditSources.server}.${auditType}`, []);
      }
      _.set(us, `${auditType}By`, _.get(data, 'uid', 'system'));
      _.set(us, `${auditType}On`, formattedDate);
      _.set(us, `${auditType}OnUtc`, utcDate);
      _.get(update, `${AuditSources.server}.${auditType}`).push(us);
      _.merge(this, update);
    }
  }
}
